import { render } from "./PreviewPayment.vue?vue&type=template&id=37ac10b5&scoped=true&ts=true"
import script from "./PreviewPayment.vue?vue&type=script&lang=ts"
export * from "./PreviewPayment.vue?vue&type=script&lang=ts"

import "./PreviewPayment.vue?vue&type=style&index=0&id=37ac10b5&lang=scss&scoped=true"

import exportComponent from "/Users/zhouyuan/work/project/hand-mobile-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ac10b5"]])

export default __exports__